import { render, staticRenderFns } from "./SosDutiesCalendar.vue?vue&type=template&id=0e6b40ab&scoped=true&lang=pug"
import script from "./SosDutiesCalendar.vue?vue&type=script&lang=js"
export * from "./SosDutiesCalendar.vue?vue&type=script&lang=js"
import style0 from "./SosDutiesCalendar.vue?vue&type=style&index=0&id=0e6b40ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6b40ab",
  null
  
)

export default component.exports